module.exports = __webpack_public_path__ + "static/media/form.c654cafb.png";